import {
  collection,
  getDocs,
  doc,
  addDoc,
  setDoc,
  deleteDoc,
  writeBatch,
} from "firebase/firestore";
import { db } from "../firebase";
import {
  firestoreDocToCategory,
  categoryToFirestore,
  staticCategories,
  sortTree,
} from "../products/categoriesModel";

const CATEGORIES = "categories";

// Public read — used by the storefront loader and the admin list.
export const fetchCategories = async () => {
  const snap = await getDocs(collection(db, CATEGORIES));
  const tree = snap.docs.map((d) => firestoreDocToCategory(d.id, d.data()));
  return sortTree(tree);
};

// --- Admin writes (gated by Firestore rules: admin claim required) --------
export const createCategory = async (category) => {
  const ref = await addDoc(collection(db, CATEGORIES), categoryToFirestore(category));
  return ref.id;
};

export const updateCategory = async (id, category) => {
  // Full replace so removed subcategories don't linger.
  await setDoc(doc(db, CATEGORIES, id), categoryToFirestore(category));
};

export const deleteCategory = async (id) => {
  await deleteDoc(doc(db, CATEGORIES, id));
};

// Persist new ordering for the whole tree in one batch.
export const saveCategoryOrder = async (tree) => {
  const batch = writeBatch(db);
  tree.forEach((cat, index) => {
    batch.set(doc(db, CATEGORIES, cat.id), categoryToFirestore({ ...cat, order: index }));
  });
  await batch.commit();
};

// One-time import of the bundled taxonomy into an empty collection.
export const seedCategoriesFromStatic = async () => {
  const batch = writeBatch(db);
  staticCategories.forEach((cat, index) => {
    const ref = doc(collection(db, CATEGORIES));
    batch.set(ref, categoryToFirestore({ ...cat, order: index }));
  });
  await batch.commit();
};
